<template>
  <div class="height100 flex flex-col">
    <div class="bg-fff margin-bottom-10">
      <div class="flex flex-between flex-align-center global-padd">
        <div class="font-18 font-bold">活动中心</div>
        <div>
          <el-button type="primary" size="small" @click="$router.push('/activity/createEdit')">
            <i class="el-icon-plus" style="margin-right: 5px"></i>添加活动
          </el-button>
        </div>
      </div>
      <div class="global-line"></div>
      <!--      <div class="global-padd-15">-->
      <!--        <el-tabs v-model="activeName" @tab-click="handleClick">-->
      <!--          <el-tab-pane label="资质已审核" name="first"></el-tab-pane>-->
      <!--          <el-tab-pane label="资质未审核" name="second"></el-tab-pane>-->
      <!--        </el-tabs>-->
      <!--      </div>-->
      <div class="global-padd-15">
        <el-form v-model="form" inline>
          <el-form-item label="活动类型：">
            <el-select size="small"
                       clearable
                       style="width: 180px"
                       v-model="form.type">
              <el-option label="赛事活动" :value="1" ></el-option>
              <el-option label="课程训练" :value="2" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关键字：">
            <el-input size="small"
                      style="width: 180px"
                      clearable
                      v-model="form.title"
                      placeholder="标题">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="primary" @click="searchCondition">搜索</el-button>
          </el-form-item>
          <!--                        <el-form-item>-->
          <!--                            <el-button size="small" type="primary" @click="exportT">导出</el-button>-->
          <!--                        </el-form-item>-->
        </el-form>
      </div>
    </div>
    <div class="flex1">
      <el-table height="100%" :data="tableData"
                :header-cell-style="{
                  background:'#f1f1f1'
                }"
                border>
        <el-table-column label="序号" width="100px">
          <template slot-scope="scope">
            <span>{{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="主题照片"  width="200px" >
          <template slot-scope="scope">
            <div style="text-align: center">
              <el-image
                  style="width: 175px;height: 60px"
                  :src="scope.row.noticeCover"
                  fit="contain"></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="活动名称" prop="noticeTitle">
        </el-table-column>
        <el-table-column label="活动类型" >
          <template slot-scope="scope">
            <span v-if="scope.row.noticeType ==1" style="color: #409EFF">赛事活动</span>
            <span v-if="scope.row.noticeType ==2" style="color: #dcac6c">课程训练</span>
          </template>
        </el-table-column>
        <el-table-column label="阅读数" prop="readCount">
        </el-table-column>
        <el-table-column label="发布时间"  >
          <template slot-scope="scope">
            {{scope.row.modifyTime | dateFormat('yyyy-MM-dd hh:mm')}}
          </template>
        </el-table-column>


        <el-table-column label="操作" >
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)"><span style="text-decoration: underline">编辑</span></el-button>
            <el-button type="text" v-if="scope.row.noticeType ==2" @click="$router.push('/activity/booking/list/'+scope.row.noticeId+'/'+scope.row.noticeTitle)"><span style="text-decoration: underline">预约记录</span></el-button>
<!--            <el-button type="text"  @click="deleteUse(scope.row)"><span style="text-decoration: underline">查看</span></el-button>-->
            <!--                        <el-button type="text" @click="TransactionDetails(scope.row)">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="text-center global-padd bg-fff">
      <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="form.page"
          :page-size="10"
          layout="total, prev, pager, next"
          :total="form.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'useManagement',
  data(){
    let _this = this
    return {
      form:{
        type:'',
        keyword:'',
        // checkState:undefined,
        // category:undefined,
        page:1 ,
        rows:10,
        total:0
      },
      tableData:[],
    }
  },
  mounted () {
    this.getList()
  },
  watch:{
  },
  methods:{
    edit(data){
      this.$router.push('/activity/createEdit/'+data.noticeId)
    },
    searchCondition(){
      this.form.page=1
      this.getList()
    },
    handleCurrentChange(a){
      this.form.page=a
      this.getList()
    },

    getList(){
      if(!this.form.type){
        // this.form.type=undefined
      }
      this.$http.post('/rest/notice/list', this.form, res => {
        this.tableData=res.data
        this.form.total=res.total
      })
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/activity/list.vue